import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
const tomos = [{
  icon: '📘',
  title: 'TOMO 1 — Manual Maestro del Carpintero de Acero',
  desc: 'La base técnica completa. Tipos de caño estructural, herramientas esenciales, corte con amoladora, técnicas de soldadura para muebles, combinación hierro-madera y acabados profesionales.',
  benefit: 'Empezás desde cero y llegás a un nivel técnico real.'
}, {
  icon: '📗',
  title: 'TOMO 2 — El Catálogo de los 10 Más Vendidos',
  desc: 'Los 10 muebles con mayor demanda en Marketplace Argentina. Planos con medidas exactas, lista de materiales y tabla de costos y ganancia de cada pieza.',
  benefit: 'Sabés exactamente qué fabricar para vender desde el día uno.'
}, {
  icon: '📙',
  title: 'TOMO 3 — Guía de Costeo y Presupuesto Anti-Inflación',
  desc: 'El sistema de precios que te protege de la inflación argentina. Fórmula Maestra de Precios, guiones para responder "está caro" sin perder la venta y planilla de costeo lista para usar.',
  benefit: 'Nunca más vendés por debajo de tu costo sin darte cuenta.'
}, {
  icon: '📕',
  title: 'TOMO 4 — Master de Ventas en Marketplace y WhatsApp',
  desc: 'El sistema completo de ventas digitales para carpinteros. Cómo publicar para el algoritmo de Marketplace, fotos que detienen el scroll y guiones de WhatsApp que cierran ventas sin regatear.',
  benefit: 'Fabricás y vendés. Sin depender de nadie.'
}, {
  icon: '📔',
  title: 'TOMO 5 — Diseños en Melamina y Muebles Combinados',
  desc: 'Expandí tu catálogo y duplicá tu ticket promedio. Colores más vendidos, diseños combinados hierro-melamina, uniones profesionales y cómo ofrecer servicio de instalación.',
  benefit: 'Más variedad, más clientes, más ingresos.'
}];
export function TomosDetail() {
  return <section className="pt-10 pb-20 px-4 bg-white" data-id="element-362">
      <div className="max-w-4xl mx-auto" data-id="element-363">
        <div className="text-center mb-16" data-id="element-364">
          <h2 className="text-4xl font-black text-brand-dark mb-4" data-id="element-365">
            Lo que recibís hoy
          </h2>
          <div className="inline-block bg-brand-steel text-white font-bold px-6 py-2 rounded-lg text-xl" data-id="element-366">
            📦 MEGA PACK — 5 Tomos Maestros
          </div>
          <p className="text-xl text-gray-600 mt-4 font-medium" data-id="element-367">
            El sistema completo para pasar de cero a tu primera venta
          </p>
        </div>

        <div className="space-y-6" data-id="element-368">
          {tomos.map((t, i) => <div key={i} className="bg-white border-2 border-gray-100 p-6 md:p-8 rounded-2xl shadow-lg flex flex-col md:flex-row gap-6 items-start" data-id="element-369">
              <div className="text-6xl flex-shrink-0" data-id="element-370">{t.icon}</div>
              <div data-id="element-371">
                <h3 className="text-2xl font-bold text-brand-dark mb-3" data-id="element-372">
                  {t.title}
                </h3>
                <p className="text-lg text-gray-600 leading-relaxed mb-3" data-id="element-373">
                  {t.desc}
                </p>
                <div className="flex items-center gap-2" data-id="element-374">
                  <CheckCircleIcon className="w-5 h-5 text-brand-green flex-shrink-0" data-id="element-375" />
                  <p className="text-lg font-bold text-brand-dark" data-id="element-376">
                    {t.benefit}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}